import * as configUtil from "util/config";
import {
    SHOW_DISABLED_ENVIRONMENTS,
    isAllowedToAccessEnvironment,
    isDisabledEnvironmentFlag,
    isEnvironmentBlocked,
} from "util/environments";

/**
 * Lista de ambientes destino para el drawer v3 (misma lógica que `NavigationBarDesktop` / `environmentsForSwitcher`).
 *
 * @param {Record<string, object>|null|undefined} environments
 * @param {number|undefined} activeEnvironmentId
 * @returns {Array<{ id: string, variant: string, label: string, blocked: boolean, isSelected: boolean }>}
 */
function buildEnvironmentSwitcherItems(environments, activeEnvironmentId) {
    if (!environments || typeof environments !== "object") {
        return [];
    }
    const showDisabledEnvironments = configUtil.getBoolean(SHOW_DISABLED_ENVIRONMENTS, false);
    const activeId =
        activeEnvironmentId !== undefined && activeEnvironmentId !== null
            ? parseInt(String(activeEnvironmentId), 10)
            : NaN;

    const passesNavbarEnvironmentFilter = (environment) => {
        if (showDisabledEnvironments) {
            return true;
        }
        return !isDisabledEnvironmentFlag(environment) && isAllowedToAccessEnvironment(environment);
    };

    const list = Object.values(environments).filter(passesNavbarEnvironmentFilter);

    return list
        .sort((a, b) => {
            if (a.environmentType === "retail" && b.environmentType !== "retail") {
                return -1;
            }
            if (a.environmentType !== "retail" && b.environmentType === "retail") {
                return 1;
            }
            return a.name.localeCompare(b.name);
        })
        .map((environment) => {
            const idNum = parseInt(environment.idEnvironment, 10);
            return {
                id: String(environment.idEnvironment),
                variant: environment.environmentType === "retail" ? "person" : "corporate",
                label: String(environment.name || "").toUpperCase(),
                blocked: isEnvironmentBlocked(environment),
                isSelected: !Number.isNaN(activeId) && idNum === activeId,
            };
        });
}

export default buildEnvironmentSwitcherItems;
